(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adg-contact-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.getElementById('AdgContactDialog');
    if (!dialog) return;

    var triggerLabel = dialog.getAttribute('data-trigger-label') || 'Nous contacter';
    var emailPattern = /(contact@atelierdesgateaux\.fr|ateliergateaux@gmail\.com|contact@atelierdesgateaux\.com)/gi;
    var excludedSelector = 'script, style, textarea, input, select, option, code, pre, button, a, #AdgContactDialog';

    function openDialog(event) {
      if (event) event.preventDefault();
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeDialog() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    function prepareTrigger(link) {
      if (link.dataset.adgContactReady === 'true') return;
      link.href = '#AdgContactDialog';
      link.classList.add('adg-contact-trigger');
      link.dataset.adgContactReady = 'true';
      link.removeAttribute('target');
      emailPattern.lastIndex = 0;
      if (emailPattern.test(link.textContent || '')) link.textContent = triggerLabel;
      emailPattern.lastIndex = 0;
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', openDialog);
    }

    function replaceTextNode(node) {
      if (!node.nodeValue || !emailPattern.test(node.nodeValue)) {
        emailPattern.lastIndex = 0;
        return;
      }
      emailPattern.lastIndex = 0;
      var parent = node.parentElement;
      if (!parent || parent.closest(excludedSelector)) return;

      var fragment = document.createDocumentFragment();
      var text = node.nodeValue;
      var lastIndex = 0;
      var match;

      while ((match = emailPattern.exec(text)) !== null) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        var link = document.createElement('a');
        link.href = '#AdgContactDialog';
        link.textContent = triggerLabel;
        link.className = 'adg-contact-trigger';
        link.dataset.adgContactReady = 'true';
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', openDialog);
        fragment.appendChild(link);
        lastIndex = match.index + match[0].length;
      }

      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      parent.replaceChild(fragment, node);
      emailPattern.lastIndex = 0;
    }

    function transformEmails(root) {
      if (!root || root.nodeType !== 1 || root.closest('#AdgContactDialog')) return;

      if (root.matches('a[href^="mailto:"]')) {
        var rootHref = root.getAttribute('href') || '';
        if (emailPattern.test(rootHref)) prepareTrigger(root);
        emailPattern.lastIndex = 0;
      }

      root.querySelectorAll('a[href^="mailto:"]').forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (emailPattern.test(href)) prepareTrigger(link);
        emailPattern.lastIndex = 0;
      });

      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(replaceTextNode);
    }

    document.querySelectorAll('[data-adg-contact-close]').forEach(function (button) {
      button.addEventListener('click', closeDialog);
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      var trigger = target && target.closest ? target.closest('a[href="#AdgContactDialog"]') : null;
      if (trigger) openDialog(event);
    }, true);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });

    transformEmails(document.body);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) transformEmails(node);
          else if (node.nodeType === 3) replaceTextNode(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    var result = dialog.querySelector('[data-adg-contact-result]');
    if (result) {
      openDialog();
      window.setTimeout(function () { result.focus(); }, 50);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
